import $ from "jquery";
import Vue from "vue";
import Component from "vue-class-component";
import { ExerciceDto } from "../../../dto/GenApi.iNotPaie.Dto/ExerciceDto";
import blockDomActionsHelper from "../../../Helper/blockDomActionsHelper";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";
import { ParametresInstance } from "../../Controls/Parameters";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";

@Component
export default class modalOuverturePremierExercice extends Vue {
    public moisSelectionne?: number;
    public anneeSelectionnee?: number;
    public isLoading = false;

    private dernierExercice?: ExerciceDto;
    private dernierExerciceAnnee?: number;
    private dernierExerciceMois?: number;

    public init(dernierExercice?: ExerciceDto): void {
        if (ParametresInstance.societeCourante == undefined) {
            return;
        }

        this.isLoading = true;

        this.dernierExercice = dernierExercice;
        this.dernierExerciceAnnee = dernierExercice?.Annee;
        this.dernierExerciceMois = dernierExercice?.Mois;

        $("#modalOuverturePremierExercice").modal("show");

        this.initExerciceParDefaut();

        this.isLoading = false;
    }

    public initExerciceParDefaut(): void {
        const anneeExerciceEnCours = ParametresInstance.societeCourante?.AnneeExerciceEnCours;
        const moisExerciceEnCours = ParametresInstance.societeCourante?.MoisExerciceEnCours;

        if (anneeExerciceEnCours != undefined && moisExerciceEnCours != undefined) {
            this.anneeSelectionnee = anneeExerciceEnCours;
            this.moisSelectionne = moisExerciceEnCours;
        } else {
            const date = new Date();
            this.anneeSelectionnee = date.getUTCFullYear();
            this.moisSelectionne = date.getUTCMonth() + 1;
        }
    }

    public annuler(): void {
        $("#modalOuverturePremierExercice").modal("hide");
    }


    public valider(): boolean | void {
        if (!this.anneeSelectionnee || !this.moisSelectionne) {
            NotificationServiceInstance.SendFailed("L'année et le mois doivent être renseignés.");
            return;
        }

        if (isNaN(Number(this.anneeSelectionnee)) || isNaN(Number(this.moisSelectionne))) {
            NotificationServiceInstance.SendFailed("L'année et le mois doivent être des entiers.");
            return;
        }

        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();

        // Vérifie que la date sélectionnée n'est pas plus d'un an après la date actuelle
        const maxYear = currentYear + 1;
        if (this.anneeSelectionnee > maxYear) {
            NotificationServiceInstance.SendFailed(`L'année doit être inférieure ou égale à ${maxYear}`);
            return;
        }

        if (this.dernierExercice === undefined) {
            // Nouvelle société : la sélection peut se faire sur n'importe quel mois de l'année courante
            if (this.anneeSelectionnee != currentYear) {
                NotificationServiceInstance.SendFailed(`La date sélectionnée doit être en ${currentYear}.`);
                return;
            }
        } else {
            // Il y a déjà des exercices : la date sélectionnée doit être strictement supérieure au dernier
            if (this.dernierExerciceAnnee !== undefined && this.dernierExerciceMois !== undefined &&
                (this.anneeSelectionnee < this.dernierExerciceAnnee ||
                    (this.anneeSelectionnee === this.dernierExerciceAnnee && this.moisSelectionne <= this.dernierExerciceMois))) {
                NotificationServiceInstance.SendFailed("La date sélectionnée doit être supérieure au dernier exercice.");
                return;
            }
        }

        this.isLoading = true;

        blockDomActionsHelper.bloquerClicks();

        ServicesFactoryInstance.ExercicesService.creerExerciceInitial(this.anneeSelectionnee, this.moisSelectionne, () => {
            NotificationServiceInstance.SendSuccess("L'exercice a bien été ouvert.");
            this.isLoading = false;
            if (ParametresInstance.societeCourante != undefined) {
                ParametresInstance.societeCourante.PeriodeActive = new Date(this.anneeSelectionnee!, this.moisSelectionne!, 1);
                ParametresInstance.societeCourante.AnneeExerciceEnCours = this.anneeSelectionnee;
                ParametresInstance.societeCourante.MoisExerciceEnCours = this.moisSelectionne;
            }

            this.$emit("refreshListeExercices");
            this.annuler();
            blockDomActionsHelper.debloquerClicks();
        },
            () => {
                NotificationServiceInstance.SendFailed("L'exercice n'a pas pu être ouvert.");
                this.isLoading = false;
                this.annuler();
                blockDomActionsHelper.debloquerClicks();
            }
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/modalComponents/modalOuverturePremierExercice/modalOuverturePremierExercice.ts